import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Chain } from 'viem';

import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';
import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { ChevronDownSmallIcon } from '@/ui/Icons/ChevronDownSmallIcon';

import {
  LIMIT_ORDER_SUPPORTED_CHAINS,
  NETWORK_NAME_PER_CHAIN_ID,
} from '../../../../constants/chain';
import { buttons } from '../../../../styles/buttons';
import { popover } from '../../../../styles/popover';

/**
 * Single-select a network with limit order support
 */
export const OpenOrdersNetworkSelect = ({
  chainId,
  onSelect,
}: {
  chainId: number | null;
  onSelect: (newChainId: number | null) => void;
}) => {
  const handleSelectNetwork = (newChainId: number | null) => {
    onSelect(newChainId);
  };

  const pop = popover();

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger
        aria-label="Select network"
        className={buttons({
          size: 'small',
          shape: 'rounded',
          color: 'gray',
          class: [
            'mt-3',
            'tablet:mt-0',
            'pr-2',
            'w-full',
            'col-[1/3]',
            'row-start-2',
            'tablet:w-fit',
            'tablet:row-start-1',
            'tablet:col-auto',
          ],
        })}
      >
        {chainId !== null && (
          <ChainAvatar
            chainId={chainId}
            alt={`${NETWORK_NAME_PER_CHAIN_ID[chainId]} logo`}
            size={16}
          />
        )}
        <span className={chainId === null ? undefined : 'ml-2'}>
          {chainId === null ? 'All networks' : NETWORK_NAME_PER_CHAIN_ID[chainId]}
        </span>
        <ChevronDownSmallIcon className="ml-auto tablet:ml-1.5 mr-0" />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content align="start" className={pop.base()}>
          <DropdownMenu.Group className={pop.items()}>
            <DropdownMenu.Item className={pop.item()} onSelect={() => handleSelectNetwork(null)}>
              <span className={chainId === null ? 'font-medium' : undefined}>All networks</span>
              {chainId === null && <CheckmarkIcon className={pop.accessoryIcon()} />}
            </DropdownMenu.Item>
            {LIMIT_ORDER_SUPPORTED_CHAINS.map((supportedChain: Chain) => {
              const selected = supportedChain.id === chainId;
              return (
                <DropdownMenu.Item
                  className={pop.item()}
                  key={supportedChain.id}
                  onSelect={() => handleSelectNetwork(supportedChain.id)}
                >
                  <ChainAvatar
                    chainId={supportedChain.id}
                    alt={`${supportedChain.name} logo`}
                    size={16}
                  />
                  <span className={selected ? 'font-medium ml-2' : 'ml-2'}>
                    {NETWORK_NAME_PER_CHAIN_ID[supportedChain.id]}
                  </span>

                  {selected && <CheckmarkIcon className={pop.accessoryIcon()} />}
                </DropdownMenu.Item>
              );
            })}
          </DropdownMenu.Group>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
